import { makeStyles } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';

const useStyles = makeStyles(theme => ({
}));
const AddRecipientScreen = ({}) => {
  const classes = useStyles()
  return (
    <>src/pages/CustomerBookingCreate/7/2/ListRecipients/1/AddRecipient/index.jsx</>
  )
}

export {AddRecipientScreen}